// source: proto/reportpb/position.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.reportpb.GetPositionAccountAllocationRequest', null, global);
goog.exportSymbol('proto.reportpb.GetPositionAccountAllocationResponse', null, global);
goog.exportSymbol('proto.reportpb.ListPositionRequest', null, global);
goog.exportSymbol('proto.reportpb.ListPositionResponse', null, global);
goog.exportSymbol('proto.reportpb.ListPositionSummary', null, global);
goog.exportSymbol('proto.reportpb.Position', null, global);
goog.exportSymbol('proto.reportpb.PositionAccountAllocation', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.Position = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.Position, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.Position.displayName = 'proto.reportpb.Position';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListPositionRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListPositionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListPositionRequest.displayName = 'proto.reportpb.ListPositionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListPositionResponse = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.reportpb.ListPositionResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.reportpb.ListPositionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListPositionResponse.displayName = 'proto.reportpb.ListPositionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListPositionSummary = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListPositionSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListPositionSummary.displayName = 'proto.reportpb.ListPositionSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.PositionAccountAllocation = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.PositionAccountAllocation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.PositionAccountAllocation.displayName =
    'proto.reportpb.PositionAccountAllocation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.GetPositionAccountAllocationRequest = function (opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.GetPositionAccountAllocationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.GetPositionAccountAllocationRequest.displayName =
    'proto.reportpb.GetPositionAccountAllocationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.GetPositionAccountAllocationResponse = function (opt_data) {
  jspb.Message.initialize(
    this,
    opt_data,
    0,
    -1,
    proto.reportpb.GetPositionAccountAllocationResponse.repeatedFields_,
    null
  );
};
goog.inherits(proto.reportpb.GetPositionAccountAllocationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.GetPositionAccountAllocationResponse.displayName =
    'proto.reportpb.GetPositionAccountAllocationResponse';
}

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.Position.prototype.toObject = function (opt_includeInstance) {
    return proto.reportpb.Position.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.Position} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.Position.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        dateType: jspb.Message.getFieldWithDefault(msg, 1, ''),
        date:
          (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
        accountId: jspb.Message.getFieldWithDefault(msg, 3, 0),
        correspondent: jspb.Message.getFieldWithDefault(msg, 4, ''),
        branch: jspb.Message.getFieldWithDefault(msg, 5, ''),
        accountNo: jspb.Message.getFieldWithDefault(msg, 6, ''),
        subAccountNo: jspb.Message.getFieldWithDefault(msg, 7, ''),
        masterAccountNo: jspb.Message.getFieldWithDefault(msg, 8, ''),
        rep: jspb.Message.getFieldWithDefault(msg, 9, ''),
        broker: jspb.Message.getFieldWithDefault(msg, 10, ''),
        marginType: jspb.Message.getFieldWithDefault(msg, 11, ''),
        type: jspb.Message.getFieldWithDefault(msg, 12, ''),
        accountName: jspb.Message.getFieldWithDefault(msg, 13, ''),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 14, ''),
        symbol: jspb.Message.getFieldWithDefault(msg, 15, ''),
        cusip: jspb.Message.getFieldWithDefault(msg, 16, ''),
        symbolDescription: jspb.Message.getFieldWithDefault(msg, 17, ''),
        assetType: jspb.Message.getFieldWithDefault(msg, 18, ''),
        closingPrice: jspb.Message.getFieldWithDefault(msg, 19, ''),
        qty: jspb.Message.getFieldWithDefault(msg, 20, ''),
        marketValue: jspb.Message.getFieldWithDefault(msg, 21, ''),
        costBasis: jspb.Message.getFieldWithDefault(msg, 22, ''),
        sdQty: jspb.Message.getFieldWithDefault(msg, 23, ''),
        sdMarketValue: jspb.Message.getFieldWithDefault(msg, 24, ''),
        sdCostBasis: jspb.Message.getFieldWithDefault(msg, 25, ''),
        sdLongQty: jspb.Message.getFieldWithDefault(msg, 26, ''),
        sdShortQty: jspb.Message.getFieldWithDefault(msg, 27, ''),
        sdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 28, ''),
        sdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 29, ''),
        side: jspb.Message.getFieldWithDefault(msg, 30, ''),
        dtccNo: jspb.Message.getFieldWithDefault(msg, 31, ''),
        location: jspb.Message.getFieldWithDefault(msg, 32, ''),
        segQty: jspb.Message.getFieldWithDefault(msg, 33, ''),
        accountStatus: jspb.Message.getFieldWithDefault(msg, 34, ''),
        participantNo: jspb.Message.getFieldWithDefault(msg, 35, ''),
        tdQty: jspb.Message.getFieldWithDefault(msg, 36, ''),
        tdMarketValue: jspb.Message.getFieldWithDefault(msg, 37, ''),
        tdCostBasis: jspb.Message.getFieldWithDefault(msg, 38, ''),
        tdLongQty: jspb.Message.getFieldWithDefault(msg, 39, ''),
        tdShortQty: jspb.Message.getFieldWithDefault(msg, 40, ''),
        tdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 41, ''),
        tdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 42, ''),
        accountCurrency: jspb.Message.getFieldWithDefault(msg, 43, ''),
        currency: jspb.Message.getFieldWithDefault(msg, 44, ''),
        currencyAmount: jspb.Message.getFieldWithDefault(msg, 45, ''),
        currencyRate: jspb.Message.getFieldWithDefault(msg, 46, ''),
        currencyPrice: jspb.Message.getFieldWithDefault(msg, 47, ''),
        lock: jspb.Message.getBooleanFieldWithDefault(msg, 48, false),
        lockReason: jspb.Message.getFieldWithDefault(msg, 49, ''),
        unsettledQty: jspb.Message.getFieldWithDefault(msg, 50, ''),
        unsettledValue: jspb.Message.getFieldWithDefault(msg, 51, ''),
        ytc: jspb.Message.getFieldWithDefault(msg, 53, ''),
        ytm: jspb.Message.getFieldWithDefault(msg, 54, ''),
        expirationDate:
          (f = msg.getExpirationDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        sic: jspb.Message.getFieldWithDefault(msg, 56, ''),
        accountType: jspb.Message.getFieldWithDefault(msg, 57, ''),
        subAccountType: jspb.Message.getFieldWithDefault(msg, 58, 0),
        reportPositionId: jspb.Message.getFieldWithDefault(msg, 59, 0),
        pc: jspb.Message.getFieldWithDefault(msg, 60, ''),
        strikePrice: jspb.Message.getFieldWithDefault(msg, 61, ''),
        underlyingSymbol: jspb.Message.getFieldWithDefault(msg, 62, ''),
        secType: jspb.Message.getFieldWithDefault(msg, 63, ''),
        lockType: jspb.Message.getFieldWithDefault(msg, 64, ''),
        positionLockQty: jspb.Message.getFieldWithDefault(msg, 65, ''),
        isArchived: jspb.Message.getBooleanFieldWithDefault(msg, 66, false),
        multiplier: jspb.Message.getFieldWithDefault(msg, 67, ''),
        inTheMoney: jspb.Message.getBooleanFieldWithDefault(msg, 68, false),
        itmOtmAmount: jspb.Message.getFieldWithDefault(msg, 69, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.Position}
 */
proto.reportpb.Position.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.Position();
  return proto.reportpb.Position.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.Position} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.Position}
 */
proto.reportpb.Position.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setDateType(value);
        break;
      case 2:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setDate(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAccountId(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCorrespondent(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setBranch(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountNo(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setSubAccountNo(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setMasterAccountNo(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setRep(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setBroker(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarginType(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setType(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountName(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbol(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setCusip(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbolDescription(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetType(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setClosingPrice(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setQty(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarketValue(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setCostBasis(value);
        break;
      case 23:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdQty(value);
        break;
      case 24:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdMarketValue(value);
        break;
      case 25:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdCostBasis(value);
        break;
      case 26:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdLongQty(value);
        break;
      case 27:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdShortQty(value);
        break;
      case 28:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdShortMarketValue(value);
        break;
      case 29:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdLongMarketValue(value);
        break;
      case 30:
        var value = /** @type {string} */ (reader.readString());
        msg.setSide(value);
        break;
      case 31:
        var value = /** @type {string} */ (reader.readString());
        msg.setDtccNo(value);
        break;
      case 32:
        var value = /** @type {string} */ (reader.readString());
        msg.setLocation(value);
        break;
      case 33:
        var value = /** @type {string} */ (reader.readString());
        msg.setSegQty(value);
        break;
      case 34:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountStatus(value);
        break;
      case 35:
        var value = /** @type {string} */ (reader.readString());
        msg.setParticipantNo(value);
        break;
      case 36:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdQty(value);
        break;
      case 37:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdMarketValue(value);
        break;
      case 38:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdCostBasis(value);
        break;
      case 39:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdLongQty(value);
        break;
      case 40:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdShortQty(value);
        break;
      case 41:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdShortMarketValue(value);
        break;
      case 42:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdLongMarketValue(value);
        break;
      case 43:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountCurrency(value);
        break;
      case 44:
        var value = /** @type {string} */ (reader.readString());
        msg.setCurrency(value);
        break;
      case 45:
        var value = /** @type {string} */ (reader.readString());
        msg.setCurrencyAmount(value);
        break;
      case 46:
        var value = /** @type {string} */ (reader.readString());
        msg.setCurrencyRate(value);
        break;
      case 47:
        var value = /** @type {string} */ (reader.readString());
        msg.setCurrencyPrice(value);
        break;
      case 48:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setLock(value);
        break;
      case 49:
        var value = /** @type {string} */ (reader.readString());
        msg.setLockReason(value);
        break;
      case 50:
        var value = /** @type {string} */ (reader.readString());
        msg.setUnsettledQty(value);
        break;
      case 51:
        var value = /** @type {string} */ (reader.readString());
        msg.setUnsettledValue(value);
        break;
      case 53:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtc(value);
        break;
      case 54:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtm(value);
        break;
      case 55:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setExpirationDate(value);
        break;
      case 56:
        var value = /** @type {string} */ (reader.readString());
        msg.setSic(value);
        break;
      case 57:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountType(value);
        break;
      case 58:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setSubAccountType(value);
        break;
      case 59:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setReportPositionId(value);
        break;
      case 60:
        var value = /** @type {string} */ (reader.readString());
        msg.setPc(value);
        break;
      case 61:
        var value = /** @type {string} */ (reader.readString());
        msg.setStrikePrice(value);
        break;
      case 62:
        var value = /** @type {string} */ (reader.readString());
        msg.setUnderlyingSymbol(value);
        break;
      case 63:
        var value = /** @type {string} */ (reader.readString());
        msg.setSecType(value);
        break;
      case 64:
        var value = /** @type {string} */ (reader.readString());
        msg.setLockType(value);
        break;
      case 65:
        var value = /** @type {string} */ (reader.readString());
        msg.setPositionLockQty(value);
        break;
      case 66:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setIsArchived(value);
        break;
      case 67:
        var value = /** @type {string} */ (reader.readString());
        msg.setMultiplier(value);
        break;
      case 68:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setInTheMoney(value);
        break;
      case 69:
        var value = /** @type {string} */ (reader.readString());
        msg.setItmOtmAmount(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.Position.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.Position.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.Position} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.Position.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(2, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(3, f);
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getSymbolDescription();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getClosingPrice();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(20, f);
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getCostBasis();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getSdQty();
  if (f.length > 0) {
    writer.writeString(23, f);
  }
  f = message.getSdMarketValue();
  if (f.length > 0) {
    writer.writeString(24, f);
  }
  f = message.getSdCostBasis();
  if (f.length > 0) {
    writer.writeString(25, f);
  }
  f = message.getSdLongQty();
  if (f.length > 0) {
    writer.writeString(26, f);
  }
  f = message.getSdShortQty();
  if (f.length > 0) {
    writer.writeString(27, f);
  }
  f = message.getSdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(28, f);
  }
  f = message.getSdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(29, f);
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(30, f);
  }
  f = message.getDtccNo();
  if (f.length > 0) {
    writer.writeString(31, f);
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(32, f);
  }
  f = message.getSegQty();
  if (f.length > 0) {
    writer.writeString(33, f);
  }
  f = message.getAccountStatus();
  if (f.length > 0) {
    writer.writeString(34, f);
  }
  f = message.getParticipantNo();
  if (f.length > 0) {
    writer.writeString(35, f);
  }
  f = message.getTdQty();
  if (f.length > 0) {
    writer.writeString(36, f);
  }
  f = message.getTdMarketValue();
  if (f.length > 0) {
    writer.writeString(37, f);
  }
  f = message.getTdCostBasis();
  if (f.length > 0) {
    writer.writeString(38, f);
  }
  f = message.getTdLongQty();
  if (f.length > 0) {
    writer.writeString(39, f);
  }
  f = message.getTdShortQty();
  if (f.length > 0) {
    writer.writeString(40, f);
  }
  f = message.getTdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(41, f);
  }
  f = message.getTdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(42, f);
  }
  f = message.getAccountCurrency();
  if (f.length > 0) {
    writer.writeString(43, f);
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(44, f);
  }
  f = message.getCurrencyAmount();
  if (f.length > 0) {
    writer.writeString(45, f);
  }
  f = message.getCurrencyRate();
  if (f.length > 0) {
    writer.writeString(46, f);
  }
  f = message.getCurrencyPrice();
  if (f.length > 0) {
    writer.writeString(47, f);
  }
  f = message.getLock();
  if (f) {
    writer.writeBool(48, f);
  }
  f = message.getLockReason();
  if (f.length > 0) {
    writer.writeString(49, f);
  }
  f = message.getUnsettledQty();
  if (f.length > 0) {
    writer.writeString(50, f);
  }
  f = message.getUnsettledValue();
  if (f.length > 0) {
    writer.writeString(51, f);
  }
  f = message.getYtc();
  if (f.length > 0) {
    writer.writeString(53, f);
  }
  f = message.getYtm();
  if (f.length > 0) {
    writer.writeString(54, f);
  }
  f = message.getExpirationDate();
  if (f != null) {
    writer.writeMessage(55, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getSic();
  if (f.length > 0) {
    writer.writeString(56, f);
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(57, f);
  }
  f = message.getSubAccountType();
  if (f !== 0) {
    writer.writeUint32(58, f);
  }
  f = message.getReportPositionId();
  if (f !== 0) {
    writer.writeUint32(59, f);
  }
  f = message.getPc();
  if (f.length > 0) {
    writer.writeString(60, f);
  }
  f = message.getStrikePrice();
  if (f.length > 0) {
    writer.writeString(61, f);
  }
  f = message.getUnderlyingSymbol();
  if (f.length > 0) {
    writer.writeString(62, f);
  }
  f = message.getSecType();
  if (f.length > 0) {
    writer.writeString(63, f);
  }
  f = message.getLockType();
  if (f.length > 0) {
    writer.writeString(64, f);
  }
  f = message.getPositionLockQty();
  if (f.length > 0) {
    writer.writeString(65, f);
  }
  f = message.getIsArchived();
  if (f) {
    writer.writeBool(66, f);
  }
  f = message.getMultiplier();
  if (f.length > 0) {
    writer.writeString(67, f);
  }
  f = message.getInTheMoney();
  if (f) {
    writer.writeBool(68, f);
  }
  f = message.getItmOtmAmount();
  if (f.length > 0) {
    writer.writeString(69, f);
  }
};

/**
 * optional string date_type = 1;
 * @return {string}
 */
proto.reportpb.Position.prototype.getDateType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setDateType = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional google.type.Date date = 2;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Position.prototype.getDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 2)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setDate = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.clearDate = function () {
  return this.setDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Position.prototype.hasDate = function () {
  return jspb.Message.getField(this, 2) != null;
};

/**
 * optional uint32 account_id = 3;
 * @return {number}
 */
proto.reportpb.Position.prototype.getAccountId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setAccountId = function (value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};

/**
 * optional string correspondent = 4;
 * @return {string}
 */
proto.reportpb.Position.prototype.getCorrespondent = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setCorrespondent = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string branch = 5;
 * @return {string}
 */
proto.reportpb.Position.prototype.getBranch = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setBranch = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string account_no = 6;
 * @return {string}
 */
proto.reportpb.Position.prototype.getAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string sub_account_no = 7;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSubAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSubAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string master_account_no = 8;
 * @return {string}
 */
proto.reportpb.Position.prototype.getMasterAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setMasterAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string rep = 9;
 * @return {string}
 */
proto.reportpb.Position.prototype.getRep = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setRep = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string broker = 10;
 * @return {string}
 */
proto.reportpb.Position.prototype.getBroker = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setBroker = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string margin_type = 11;
 * @return {string}
 */
proto.reportpb.Position.prototype.getMarginType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setMarginType = function (value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string type = 12;
 * @return {string}
 */
proto.reportpb.Position.prototype.getType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setType = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string account_name = 13;
 * @return {string}
 */
proto.reportpb.Position.prototype.getAccountName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setAccountName = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string original_cusip = 14;
 * @return {string}
 */
proto.reportpb.Position.prototype.getOriginalCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setOriginalCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string symbol = 15;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSymbol = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSymbol = function (value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string cusip = 16;
 * @return {string}
 */
proto.reportpb.Position.prototype.getCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string symbol_description = 17;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSymbolDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSymbolDescription = function (value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional string asset_type = 18;
 * @return {string}
 */
proto.reportpb.Position.prototype.getAssetType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setAssetType = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional string closing_price = 19;
 * @return {string}
 */
proto.reportpb.Position.prototype.getClosingPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setClosingPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional string qty = 20;
 * @return {string}
 */
proto.reportpb.Position.prototype.getQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setQty = function (value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};

/**
 * optional string market_value = 21;
 * @return {string}
 */
proto.reportpb.Position.prototype.getMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};

/**
 * optional string cost_basis = 22;
 * @return {string}
 */
proto.reportpb.Position.prototype.getCostBasis = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setCostBasis = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string sd_qty = 23;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSdQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSdQty = function (value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};

/**
 * optional string sd_market_value = 24;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSdMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSdMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};

/**
 * optional string sd_cost_basis = 25;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSdCostBasis = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSdCostBasis = function (value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};

/**
 * optional string sd_long_qty = 26;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSdLongQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSdLongQty = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};

/**
 * optional string sd_short_qty = 27;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSdShortQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSdShortQty = function (value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};

/**
 * optional string sd_short_market_value = 28;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSdShortMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSdShortMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};

/**
 * optional string sd_long_market_value = 29;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSdLongMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSdLongMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};

/**
 * optional string side = 30;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSide = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSide = function (value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};

/**
 * optional string dtcc_no = 31;
 * @return {string}
 */
proto.reportpb.Position.prototype.getDtccNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setDtccNo = function (value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};

/**
 * optional string location = 32;
 * @return {string}
 */
proto.reportpb.Position.prototype.getLocation = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setLocation = function (value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};

/**
 * optional string seg_qty = 33;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSegQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSegQty = function (value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};

/**
 * optional string account_status = 34;
 * @return {string}
 */
proto.reportpb.Position.prototype.getAccountStatus = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setAccountStatus = function (value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};

/**
 * optional string participant_no = 35;
 * @return {string}
 */
proto.reportpb.Position.prototype.getParticipantNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setParticipantNo = function (value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};

/**
 * optional string td_qty = 36;
 * @return {string}
 */
proto.reportpb.Position.prototype.getTdQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setTdQty = function (value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};

/**
 * optional string td_market_value = 37;
 * @return {string}
 */
proto.reportpb.Position.prototype.getTdMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setTdMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};

/**
 * optional string td_cost_basis = 38;
 * @return {string}
 */
proto.reportpb.Position.prototype.getTdCostBasis = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setTdCostBasis = function (value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};

/**
 * optional string td_long_qty = 39;
 * @return {string}
 */
proto.reportpb.Position.prototype.getTdLongQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setTdLongQty = function (value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};

/**
 * optional string td_short_qty = 40;
 * @return {string}
 */
proto.reportpb.Position.prototype.getTdShortQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setTdShortQty = function (value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};

/**
 * optional string td_short_market_value = 41;
 * @return {string}
 */
proto.reportpb.Position.prototype.getTdShortMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setTdShortMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};

/**
 * optional string td_long_market_value = 42;
 * @return {string}
 */
proto.reportpb.Position.prototype.getTdLongMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setTdLongMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};

/**
 * optional string account_currency = 43;
 * @return {string}
 */
proto.reportpb.Position.prototype.getAccountCurrency = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setAccountCurrency = function (value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};

/**
 * optional string currency = 44;
 * @return {string}
 */
proto.reportpb.Position.prototype.getCurrency = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setCurrency = function (value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};

/**
 * optional string currency_amount = 45;
 * @return {string}
 */
proto.reportpb.Position.prototype.getCurrencyAmount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setCurrencyAmount = function (value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};

/**
 * optional string currency_rate = 46;
 * @return {string}
 */
proto.reportpb.Position.prototype.getCurrencyRate = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setCurrencyRate = function (value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};

/**
 * optional string currency_price = 47;
 * @return {string}
 */
proto.reportpb.Position.prototype.getCurrencyPrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setCurrencyPrice = function (value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};

/**
 * optional bool lock = 48;
 * @return {boolean}
 */
proto.reportpb.Position.prototype.getLock = function () {
  return /** @type {boolean} */ (
    jspb.Message.getBooleanFieldWithDefault(this, 48, false)
  );
};

/**
 * @param {boolean} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setLock = function (value) {
  return jspb.Message.setProto3BooleanField(this, 48, value);
};

/**
 * optional string lock_reason = 49;
 * @return {string}
 */
proto.reportpb.Position.prototype.getLockReason = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setLockReason = function (value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};

/**
 * optional string unsettled_qty = 50;
 * @return {string}
 */
proto.reportpb.Position.prototype.getUnsettledQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setUnsettledQty = function (value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};

/**
 * optional string unsettled_value = 51;
 * @return {string}
 */
proto.reportpb.Position.prototype.getUnsettledValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setUnsettledValue = function (value) {
  return jspb.Message.setProto3StringField(this, 51, value);
};

/**
 * optional string ytc = 53;
 * @return {string}
 */
proto.reportpb.Position.prototype.getYtc = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setYtc = function (value) {
  return jspb.Message.setProto3StringField(this, 53, value);
};

/**
 * optional string ytm = 54;
 * @return {string}
 */
proto.reportpb.Position.prototype.getYtm = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 54, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setYtm = function (value) {
  return jspb.Message.setProto3StringField(this, 54, value);
};

/**
 * optional google.type.Date expiration_date = 55;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.Position.prototype.getExpirationDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 55)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setExpirationDate = function (value) {
  return jspb.Message.setWrapperField(this, 55, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.clearExpirationDate = function () {
  return this.setExpirationDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.Position.prototype.hasExpirationDate = function () {
  return jspb.Message.getField(this, 55) != null;
};

/**
 * optional string sic = 56;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSic = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSic = function (value) {
  return jspb.Message.setProto3StringField(this, 56, value);
};

/**
 * optional string account_type = 57;
 * @return {string}
 */
proto.reportpb.Position.prototype.getAccountType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setAccountType = function (value) {
  return jspb.Message.setProto3StringField(this, 57, value);
};

/**
 * optional uint32 sub_account_type = 58;
 * @return {number}
 */
proto.reportpb.Position.prototype.getSubAccountType = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 58, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSubAccountType = function (value) {
  return jspb.Message.setProto3IntField(this, 58, value);
};

/**
 * optional uint32 report_position_id = 59;
 * @return {number}
 */
proto.reportpb.Position.prototype.getReportPositionId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 59, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setReportPositionId = function (value) {
  return jspb.Message.setProto3IntField(this, 59, value);
};

/**
 * optional string pc = 60;
 * @return {string}
 */
proto.reportpb.Position.prototype.getPc = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setPc = function (value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};

/**
 * optional string strike_price = 61;
 * @return {string}
 */
proto.reportpb.Position.prototype.getStrikePrice = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setStrikePrice = function (value) {
  return jspb.Message.setProto3StringField(this, 61, value);
};

/**
 * optional string underlying_symbol = 62;
 * @return {string}
 */
proto.reportpb.Position.prototype.getUnderlyingSymbol = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 62, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setUnderlyingSymbol = function (value) {
  return jspb.Message.setProto3StringField(this, 62, value);
};

/**
 * optional string sec_type = 63;
 * @return {string}
 */
proto.reportpb.Position.prototype.getSecType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 63, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setSecType = function (value) {
  return jspb.Message.setProto3StringField(this, 63, value);
};

/**
 * optional string lock_type = 64;
 * @return {string}
 */
proto.reportpb.Position.prototype.getLockType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 64, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setLockType = function (value) {
  return jspb.Message.setProto3StringField(this, 64, value);
};

/**
 * optional string position_lock_qty = 65;
 * @return {string}
 */
proto.reportpb.Position.prototype.getPositionLockQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 65, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setPositionLockQty = function (value) {
  return jspb.Message.setProto3StringField(this, 65, value);
};

/**
 * optional bool is_archived = 66;
 * @return {boolean}
 */
proto.reportpb.Position.prototype.getIsArchived = function () {
  return /** @type {boolean} */ (
    jspb.Message.getBooleanFieldWithDefault(this, 66, false)
  );
};

/**
 * @param {boolean} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setIsArchived = function (value) {
  return jspb.Message.setProto3BooleanField(this, 66, value);
};

/**
 * optional string multiplier = 67;
 * @return {string}
 */
proto.reportpb.Position.prototype.getMultiplier = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setMultiplier = function (value) {
  return jspb.Message.setProto3StringField(this, 67, value);
};

/**
 * optional bool in_the_money = 68;
 * @return {boolean}
 */
proto.reportpb.Position.prototype.getInTheMoney = function () {
  return /** @type {boolean} */ (
    jspb.Message.getBooleanFieldWithDefault(this, 68, false)
  );
};

/**
 * @param {boolean} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setInTheMoney = function (value) {
  return jspb.Message.setProto3BooleanField(this, 68, value);
};

/**
 * optional string itm_otm_amount = 69;
 * @return {string}
 */
proto.reportpb.Position.prototype.getItmOtmAmount = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 69, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.Position} returns this
 */
proto.reportpb.Position.prototype.setItmOtmAmount = function (value) {
  return jspb.Message.setProto3StringField(this, 69, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListPositionRequest.prototype.toObject = function (opt_includeInstance) {
    return proto.reportpb.ListPositionRequest.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListPositionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListPositionRequest.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        correspondent: jspb.Message.getFieldWithDefault(msg, 1, ''),
        accountNo: jspb.Message.getFieldWithDefault(msg, 2, ''),
        accountName: jspb.Message.getFieldWithDefault(msg, 3, ''),
        masterAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ''),
        unpricedSecurity: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
        broker: jspb.Message.getFieldWithDefault(msg, 6, ''),
        type: jspb.Message.getFieldWithDefault(msg, 7, ''),
        symbol: jspb.Message.getFieldWithDefault(msg, 8, ''),
        cusip: jspb.Message.getFieldWithDefault(msg, 9, ''),
        dateType: jspb.Message.getFieldWithDefault(msg, 10, ''),
        pagination:
          (f = msg.getPagination()) &&
          proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
        branch: jspb.Message.getFieldWithDefault(msg, 12, ''),
        rep: jspb.Message.getFieldWithDefault(msg, 13, ''),
        assetType: jspb.Message.getFieldWithDefault(msg, 14, ''),
        originalCusip: jspb.Message.getFieldWithDefault(msg, 15, ''),
        fromDate:
          (f = msg.getFromDate()) &&
          google_type_date_pb.Date.toObject(includeInstance, f),
        toDate:
          (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
        securityType: jspb.Message.getFieldWithDefault(msg, 18, ''),
        secSubType: jspb.Message.getFieldWithDefault(msg, 19, ''),
        side: jspb.Message.getFieldWithDefault(msg, 20, ''),
        subAccountNo: jspb.Message.getFieldWithDefault(msg, 21, ''),
        participantNo: jspb.Message.getFieldWithDefault(msg, 22, ''),
        location: jspb.Message.getFieldWithDefault(msg, 23, ''),
        fractionalShare: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
        accountCurrency: jspb.Message.getFieldWithDefault(msg, 25, ''),
        currency: jspb.Message.getFieldWithDefault(msg, 26, ''),
        rollUp: jspb.Message.getFieldWithDefault(msg, 27, ''),
        subAccountType: jspb.Message.getFieldWithDefault(msg, 29, 0),
        boxed: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
        accountId: jspb.Message.getFieldWithDefault(msg, 31, 0),
        marginType: jspb.Message.getFieldWithDefault(msg, 32, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListPositionRequest}
 */
proto.reportpb.ListPositionRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListPositionRequest();
  return proto.reportpb.ListPositionRequest.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListPositionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListPositionRequest}
 */
proto.reportpb.ListPositionRequest.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCorrespondent(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountNo(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountName(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setMasterAccountNo(value);
        break;
      case 5:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setUnpricedSecurity(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setBroker(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setType(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setSymbol(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setCusip(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setDateType(value);
        break;
      case 11:
        var value = new proto_utilspb_pagination_pb.Pagination();
        reader.readMessage(
          value,
          proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader
        );
        msg.setPagination(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setBranch(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setRep(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetType(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setOriginalCusip(value);
        break;
      case 16:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setFromDate(value);
        break;
      case 17:
        var value = new google_type_date_pb.Date();
        reader.readMessage(value, google_type_date_pb.Date.deserializeBinaryFromReader);
        msg.setToDate(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setSecurityType(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setSecSubType(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setSide(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setSubAccountNo(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setParticipantNo(value);
        break;
      case 23:
        var value = /** @type {string} */ (reader.readString());
        msg.setLocation(value);
        break;
      case 24:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setFractionalShare(value);
        break;
      case 25:
        var value = /** @type {string} */ (reader.readString());
        msg.setAccountCurrency(value);
        break;
      case 26:
        var value = /** @type {string} */ (reader.readString());
        msg.setCurrency(value);
        break;
      case 27:
        var value = /** @type {string} */ (reader.readString());
        msg.setRollUp(value);
        break;
      case 29:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setSubAccountType(value);
        break;
      case 30:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setBoxed(value);
        break;
      case 31:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setAccountId(value);
        break;
      case 32:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarginType(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListPositionRequest.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListPositionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListPositionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListPositionRequest.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getUnpricedSecurity();
  if (f) {
    writer.writeBool(5, f);
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getCusip();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getAssetType();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getOriginalCusip();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(16, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(17, f, google_type_date_pb.Date.serializeBinaryToWriter);
  }
  f = message.getSecurityType();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getSecSubType();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(20, f);
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
  f = message.getParticipantNo();
  if (f.length > 0) {
    writer.writeString(22, f);
  }
  f = message.getLocation();
  if (f.length > 0) {
    writer.writeString(23, f);
  }
  f = message.getFractionalShare();
  if (f) {
    writer.writeBool(24, f);
  }
  f = message.getAccountCurrency();
  if (f.length > 0) {
    writer.writeString(25, f);
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(26, f);
  }
  f = message.getRollUp();
  if (f.length > 0) {
    writer.writeString(27, f);
  }
  f = message.getSubAccountType();
  if (f !== 0) {
    writer.writeUint32(29, f);
  }
  f = message.getBoxed();
  if (f) {
    writer.writeBool(30, f);
  }
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(31, f);
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(32, f);
  }
};

/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getCorrespondent = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setCorrespondent = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string account_name = 3;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getAccountName = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setAccountName = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string master_account_no = 4;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getMasterAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setMasterAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional bool unpriced_security = 5;
 * @return {boolean}
 */
proto.reportpb.ListPositionRequest.prototype.getUnpricedSecurity = function () {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};

/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setUnpricedSecurity = function (value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};

/**
 * optional string broker = 6;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getBroker = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setBroker = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string type = 7;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setType = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string symbol = 8;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getSymbol = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setSymbol = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string cusip = 9;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string date_type = 10;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getDateType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setDateType = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional utilspb.Pagination pagination = 11;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ListPositionRequest.prototype.getPagination = function () {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 11)
  );
};

/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setPagination = function (value) {
  return jspb.Message.setWrapperField(this, 11, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.clearPagination = function () {
  return this.setPagination(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListPositionRequest.prototype.hasPagination = function () {
  return jspb.Message.getField(this, 11) != null;
};

/**
 * optional string branch = 12;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getBranch = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setBranch = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string rep = 13;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getRep = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setRep = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string asset_type = 14;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getAssetType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setAssetType = function (value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string original_cusip = 15;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getOriginalCusip = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setOriginalCusip = function (value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional google.type.Date from_date = 16;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListPositionRequest.prototype.getFromDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 16)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setFromDate = function (value) {
  return jspb.Message.setWrapperField(this, 16, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.clearFromDate = function () {
  return this.setFromDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListPositionRequest.prototype.hasFromDate = function () {
  return jspb.Message.getField(this, 16) != null;
};

/**
 * optional google.type.Date to_date = 17;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListPositionRequest.prototype.getToDate = function () {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 17)
  );
};

/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setToDate = function (value) {
  return jspb.Message.setWrapperField(this, 17, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.clearToDate = function () {
  return this.setToDate(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListPositionRequest.prototype.hasToDate = function () {
  return jspb.Message.getField(this, 17) != null;
};

/**
 * optional string security_type = 18;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getSecurityType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setSecurityType = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional string sec_sub_type = 19;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getSecSubType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setSecSubType = function (value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional string side = 20;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getSide = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setSide = function (value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};

/**
 * optional string sub_account_no = 21;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getSubAccountNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setSubAccountNo = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};

/**
 * optional string participant_no = 22;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getParticipantNo = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setParticipantNo = function (value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};

/**
 * optional string location = 23;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getLocation = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setLocation = function (value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};

/**
 * optional bool fractional_share = 24;
 * @return {boolean}
 */
proto.reportpb.ListPositionRequest.prototype.getFractionalShare = function () {
  return /** @type {boolean} */ (
    jspb.Message.getBooleanFieldWithDefault(this, 24, false)
  );
};

/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setFractionalShare = function (value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};

/**
 * optional string account_currency = 25;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getAccountCurrency = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setAccountCurrency = function (value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};

/**
 * optional string currency = 26;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getCurrency = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setCurrency = function (value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};

/**
 * optional string roll_up = 27;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getRollUp = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setRollUp = function (value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};

/**
 * optional uint32 sub_account_type = 29;
 * @return {number}
 */
proto.reportpb.ListPositionRequest.prototype.getSubAccountType = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setSubAccountType = function (value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};

/**
 * optional bool boxed = 30;
 * @return {boolean}
 */
proto.reportpb.ListPositionRequest.prototype.getBoxed = function () {
  return /** @type {boolean} */ (
    jspb.Message.getBooleanFieldWithDefault(this, 30, false)
  );
};

/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setBoxed = function (value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};

/**
 * optional uint32 account_id = 31;
 * @return {number}
 */
proto.reportpb.ListPositionRequest.prototype.getAccountId = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setAccountId = function (value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};

/**
 * optional string margin_type = 32;
 * @return {string}
 */
proto.reportpb.ListPositionRequest.prototype.getMarginType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionRequest} returns this
 */
proto.reportpb.ListPositionRequest.prototype.setMarginType = function (value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListPositionResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListPositionResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.reportpb.ListPositionResponse.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListPositionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListPositionResponse.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        positionsList: jspb.Message.toObjectList(
          msg.getPositionsList(),
          proto.reportpb.Position.toObject,
          includeInstance
        ),
        summary:
          (f = msg.getSummary()) &&
          proto.reportpb.ListPositionSummary.toObject(includeInstance, f),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListPositionResponse}
 */
proto.reportpb.ListPositionResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListPositionResponse();
  return proto.reportpb.ListPositionResponse.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListPositionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListPositionResponse}
 */
proto.reportpb.ListPositionResponse.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.reportpb.Position();
        reader.readMessage(value, proto.reportpb.Position.deserializeBinaryFromReader);
        msg.addPositions(value);
        break;
      case 2:
        var value = new proto.reportpb.ListPositionSummary();
        reader.readMessage(
          value,
          proto.reportpb.ListPositionSummary.deserializeBinaryFromReader
        );
        msg.setSummary(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListPositionResponse.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListPositionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListPositionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListPositionResponse.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getPositionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(1, f, proto.reportpb.Position.serializeBinaryToWriter);
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(2, f, proto.reportpb.ListPositionSummary.serializeBinaryToWriter);
  }
};

/**
 * repeated Position positions = 1;
 * @return {!Array<!proto.reportpb.Position>}
 */
proto.reportpb.ListPositionResponse.prototype.getPositionsList = function () {
  return /** @type{!Array<!proto.reportpb.Position>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.Position, 1)
  );
};

/**
 * @param {!Array<!proto.reportpb.Position>} value
 * @return {!proto.reportpb.ListPositionResponse} returns this
 */
proto.reportpb.ListPositionResponse.prototype.setPositionsList = function (value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};

/**
 * @param {!proto.reportpb.Position=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.Position}
 */
proto.reportpb.ListPositionResponse.prototype.addPositions = function (
  opt_value,
  opt_index
) {
  return jspb.Message.addToRepeatedWrapperField(
    this,
    1,
    opt_value,
    proto.reportpb.Position,
    opt_index
  );
};

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListPositionResponse} returns this
 */
proto.reportpb.ListPositionResponse.prototype.clearPositionsList = function () {
  return this.setPositionsList([]);
};

/**
 * optional ListPositionSummary summary = 2;
 * @return {?proto.reportpb.ListPositionSummary}
 */
proto.reportpb.ListPositionResponse.prototype.getSummary = function () {
  return /** @type{?proto.reportpb.ListPositionSummary} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ListPositionSummary, 2)
  );
};

/**
 * @param {?proto.reportpb.ListPositionSummary|undefined} value
 * @return {!proto.reportpb.ListPositionResponse} returns this
 */
proto.reportpb.ListPositionResponse.prototype.setSummary = function (value) {
  return jspb.Message.setWrapperField(this, 2, value);
};

/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListPositionResponse} returns this
 */
proto.reportpb.ListPositionResponse.prototype.clearSummary = function () {
  return this.setSummary(undefined);
};

/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListPositionResponse.prototype.hasSummary = function () {
  return jspb.Message.getField(this, 2) != null;
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.ListPositionSummary.prototype.toObject = function (opt_includeInstance) {
    return proto.reportpb.ListPositionSummary.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.ListPositionSummary} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.ListPositionSummary.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0),
        qty: jspb.Message.getFieldWithDefault(msg, 2, ''),
        marketValue: jspb.Message.getFieldWithDefault(msg, 3, ''),
        costBasis: jspb.Message.getFieldWithDefault(msg, 4, ''),
        sdQty: jspb.Message.getFieldWithDefault(msg, 5, ''),
        sdMarketValue: jspb.Message.getFieldWithDefault(msg, 6, ''),
        sdCostBasis: jspb.Message.getFieldWithDefault(msg, 7, ''),
        sdLongQty: jspb.Message.getFieldWithDefault(msg, 8, ''),
        sdShortQty: jspb.Message.getFieldWithDefault(msg, 9, ''),
        sdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 10, ''),
        sdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 11, ''),
        tdQty: jspb.Message.getFieldWithDefault(msg, 12, ''),
        tdMarketValue: jspb.Message.getFieldWithDefault(msg, 13, ''),
        tdCostBasis: jspb.Message.getFieldWithDefault(msg, 14, ''),
        tdLongQty: jspb.Message.getFieldWithDefault(msg, 15, ''),
        tdShortQty: jspb.Message.getFieldWithDefault(msg, 16, ''),
        tdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 17, ''),
        tdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 18, ''),
        segQty: jspb.Message.getFieldWithDefault(msg, 19, ''),
        ytc: jspb.Message.getFieldWithDefault(msg, 20, ''),
        ytm: jspb.Message.getFieldWithDefault(msg, 21, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListPositionSummary}
 */
proto.reportpb.ListPositionSummary.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListPositionSummary();
  return proto.reportpb.ListPositionSummary.deserializeBinaryFromReader(msg, reader);
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListPositionSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListPositionSummary}
 */
proto.reportpb.ListPositionSummary.deserializeBinaryFromReader = function (msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readUint32());
        msg.setTotalRows(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setQty(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setMarketValue(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCostBasis(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdQty(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdMarketValue(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdCostBasis(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdLongQty(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdShortQty(value);
        break;
      case 10:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdShortMarketValue(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setSdLongMarketValue(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdQty(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdMarketValue(value);
        break;
      case 14:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdCostBasis(value);
        break;
      case 15:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdLongQty(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdShortQty(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdShortMarketValue(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setTdLongMarketValue(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setSegQty(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtc(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setYtm(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListPositionSummary.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListPositionSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListPositionSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListPositionSummary.serializeBinaryToWriter = function (message, writer) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(1, f);
  }
  f = message.getQty();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getMarketValue();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
  f = message.getCostBasis();
  if (f.length > 0) {
    writer.writeString(4, f);
  }
  f = message.getSdQty();
  if (f.length > 0) {
    writer.writeString(5, f);
  }
  f = message.getSdMarketValue();
  if (f.length > 0) {
    writer.writeString(6, f);
  }
  f = message.getSdCostBasis();
  if (f.length > 0) {
    writer.writeString(7, f);
  }
  f = message.getSdLongQty();
  if (f.length > 0) {
    writer.writeString(8, f);
  }
  f = message.getSdShortQty();
  if (f.length > 0) {
    writer.writeString(9, f);
  }
  f = message.getSdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(10, f);
  }
  f = message.getSdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(11, f);
  }
  f = message.getTdQty();
  if (f.length > 0) {
    writer.writeString(12, f);
  }
  f = message.getTdMarketValue();
  if (f.length > 0) {
    writer.writeString(13, f);
  }
  f = message.getTdCostBasis();
  if (f.length > 0) {
    writer.writeString(14, f);
  }
  f = message.getTdLongQty();
  if (f.length > 0) {
    writer.writeString(15, f);
  }
  f = message.getTdShortQty();
  if (f.length > 0) {
    writer.writeString(16, f);
  }
  f = message.getTdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(17, f);
  }
  f = message.getTdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(18, f);
  }
  f = message.getSegQty();
  if (f.length > 0) {
    writer.writeString(19, f);
  }
  f = message.getYtc();
  if (f.length > 0) {
    writer.writeString(20, f);
  }
  f = message.getYtm();
  if (f.length > 0) {
    writer.writeString(21, f);
  }
};

/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ListPositionSummary.prototype.getTotalRows = function () {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};

/**
 * @param {number} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTotalRows = function (value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};

/**
 * optional string qty = 2;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setQty = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string market_value = 3;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

/**
 * optional string cost_basis = 4;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getCostBasis = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setCostBasis = function (value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};

/**
 * optional string sd_qty = 5;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSdQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSdQty = function (value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};

/**
 * optional string sd_market_value = 6;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSdMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSdMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};

/**
 * optional string sd_cost_basis = 7;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSdCostBasis = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSdCostBasis = function (value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};

/**
 * optional string sd_long_qty = 8;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSdLongQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSdLongQty = function (value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};

/**
 * optional string sd_short_qty = 9;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSdShortQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSdShortQty = function (value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};

/**
 * optional string sd_short_market_value = 10;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSdShortMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSdShortMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};

/**
 * optional string sd_long_market_value = 11;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSdLongMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSdLongMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};

/**
 * optional string td_qty = 12;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getTdQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTdQty = function (value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};

/**
 * optional string td_market_value = 13;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getTdMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTdMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};

/**
 * optional string td_cost_basis = 14;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getTdCostBasis = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTdCostBasis = function (value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};

/**
 * optional string td_long_qty = 15;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getTdLongQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTdLongQty = function (value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};

/**
 * optional string td_short_qty = 16;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getTdShortQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTdShortQty = function (value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};

/**
 * optional string td_short_market_value = 17;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getTdShortMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTdShortMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};

/**
 * optional string td_long_market_value = 18;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getTdLongMarketValue = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setTdLongMarketValue = function (value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};

/**
 * optional string seg_qty = 19;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getSegQty = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setSegQty = function (value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};

/**
 * optional string ytc = 20;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getYtc = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setYtc = function (value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};

/**
 * optional string ytm = 21;
 * @return {string}
 */
proto.reportpb.ListPositionSummary.prototype.getYtm = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.ListPositionSummary} returns this
 */
proto.reportpb.ListPositionSummary.prototype.setYtm = function (value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.PositionAccountAllocation.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.reportpb.PositionAccountAllocation.toObject(opt_includeInstance, this);
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.PositionAccountAllocation} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.PositionAccountAllocation.toObject = function (includeInstance, msg) {
    var f,
      obj = {
        percentage: jspb.Message.getFieldWithDefault(msg, 1, ''),
        code: jspb.Message.getFieldWithDefault(msg, 2, ''),
        description: jspb.Message.getFieldWithDefault(msg, 3, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.PositionAccountAllocation}
 */
proto.reportpb.PositionAccountAllocation.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.PositionAccountAllocation();
  return proto.reportpb.PositionAccountAllocation.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.PositionAccountAllocation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.PositionAccountAllocation}
 */
proto.reportpb.PositionAccountAllocation.deserializeBinaryFromReader = function (
  msg,
  reader
) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setPercentage(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCode(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setDescription(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.PositionAccountAllocation.prototype.serializeBinary = function () {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.PositionAccountAllocation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.PositionAccountAllocation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.PositionAccountAllocation.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getPercentage();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(2, f);
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(3, f);
  }
};

/**
 * optional string percentage = 1;
 * @return {string}
 */
proto.reportpb.PositionAccountAllocation.prototype.getPercentage = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.PositionAccountAllocation} returns this
 */
proto.reportpb.PositionAccountAllocation.prototype.setPercentage = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * optional string code = 2;
 * @return {string}
 */
proto.reportpb.PositionAccountAllocation.prototype.getCode = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.PositionAccountAllocation} returns this
 */
proto.reportpb.PositionAccountAllocation.prototype.setCode = function (value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};

/**
 * optional string description = 3;
 * @return {string}
 */
proto.reportpb.PositionAccountAllocation.prototype.getDescription = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.PositionAccountAllocation} returns this
 */
proto.reportpb.PositionAccountAllocation.prototype.setDescription = function (value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.GetPositionAccountAllocationRequest.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.reportpb.GetPositionAccountAllocationRequest.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.GetPositionAccountAllocationRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.GetPositionAccountAllocationRequest.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        type: jspb.Message.getFieldWithDefault(msg, 1, ''),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.GetPositionAccountAllocationRequest}
 */
proto.reportpb.GetPositionAccountAllocationRequest.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.GetPositionAccountAllocationRequest();
  return proto.reportpb.GetPositionAccountAllocationRequest.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.GetPositionAccountAllocationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.GetPositionAccountAllocationRequest}
 */
proto.reportpb.GetPositionAccountAllocationRequest.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = /** @type {string} */ (reader.readString());
          msg.setType(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.GetPositionAccountAllocationRequest.prototype.serializeBinary =
  function () {
    var writer = new jspb.BinaryWriter();
    proto.reportpb.GetPositionAccountAllocationRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.GetPositionAccountAllocationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.GetPositionAccountAllocationRequest.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(1, f);
  }
};

/**
 * optional string type = 1;
 * @return {string}
 */
proto.reportpb.GetPositionAccountAllocationRequest.prototype.getType = function () {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ''));
};

/**
 * @param {string} value
 * @return {!proto.reportpb.GetPositionAccountAllocationRequest} returns this
 */
proto.reportpb.GetPositionAccountAllocationRequest.prototype.setType = function (value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.GetPositionAccountAllocationResponse.repeatedFields_ = [1];

if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.reportpb.GetPositionAccountAllocationResponse.prototype.toObject = function (
    opt_includeInstance
  ) {
    return proto.reportpb.GetPositionAccountAllocationResponse.toObject(
      opt_includeInstance,
      this
    );
  };

  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.reportpb.GetPositionAccountAllocationResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.reportpb.GetPositionAccountAllocationResponse.toObject = function (
    includeInstance,
    msg
  ) {
    var f,
      obj = {
        positionAccountAllocationsList: jspb.Message.toObjectList(
          msg.getPositionAccountAllocationsList(),
          proto.reportpb.PositionAccountAllocation.toObject,
          includeInstance
        ),
      };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.GetPositionAccountAllocationResponse}
 */
proto.reportpb.GetPositionAccountAllocationResponse.deserializeBinary = function (bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.GetPositionAccountAllocationResponse();
  return proto.reportpb.GetPositionAccountAllocationResponse.deserializeBinaryFromReader(
    msg,
    reader
  );
};

/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.GetPositionAccountAllocationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.GetPositionAccountAllocationResponse}
 */
proto.reportpb.GetPositionAccountAllocationResponse.deserializeBinaryFromReader =
  function (msg, reader) {
    while (reader.nextField()) {
      if (reader.isEndGroup()) {
        break;
      }
      var field = reader.getFieldNumber();
      switch (field) {
        case 1:
          var value = new proto.reportpb.PositionAccountAllocation();
          reader.readMessage(
            value,
            proto.reportpb.PositionAccountAllocation.deserializeBinaryFromReader
          );
          msg.addPositionAccountAllocations(value);
          break;
        default:
          reader.skipField();
          break;
      }
    }
    return msg;
  };

/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.GetPositionAccountAllocationResponse.prototype.serializeBinary =
  function () {
    var writer = new jspb.BinaryWriter();
    proto.reportpb.GetPositionAccountAllocationResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  };

/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.GetPositionAccountAllocationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.GetPositionAccountAllocationResponse.serializeBinaryToWriter = function (
  message,
  writer
) {
  var f = undefined;
  f = message.getPositionAccountAllocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.PositionAccountAllocation.serializeBinaryToWriter
    );
  }
};

/**
 * repeated PositionAccountAllocation position_account_allocations = 1;
 * @return {!Array<!proto.reportpb.PositionAccountAllocation>}
 */
proto.reportpb.GetPositionAccountAllocationResponse.prototype.getPositionAccountAllocationsList =
  function () {
    return /** @type{!Array<!proto.reportpb.PositionAccountAllocation>} */ (
      jspb.Message.getRepeatedWrapperField(
        this,
        proto.reportpb.PositionAccountAllocation,
        1
      )
    );
  };

/**
 * @param {!Array<!proto.reportpb.PositionAccountAllocation>} value
 * @return {!proto.reportpb.GetPositionAccountAllocationResponse} returns this
 */
proto.reportpb.GetPositionAccountAllocationResponse.prototype.setPositionAccountAllocationsList =
  function (value) {
    return jspb.Message.setRepeatedWrapperField(this, 1, value);
  };

/**
 * @param {!proto.reportpb.PositionAccountAllocation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.PositionAccountAllocation}
 */
proto.reportpb.GetPositionAccountAllocationResponse.prototype.addPositionAccountAllocations =
  function (opt_value, opt_index) {
    return jspb.Message.addToRepeatedWrapperField(
      this,
      1,
      opt_value,
      proto.reportpb.PositionAccountAllocation,
      opt_index
    );
  };

/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.GetPositionAccountAllocationResponse} returns this
 */
proto.reportpb.GetPositionAccountAllocationResponse.prototype.clearPositionAccountAllocationsList =
  function () {
    return this.setPositionAccountAllocationsList([]);
  };

goog.object.extend(exports, proto.reportpb);
